import React from 'react';
// STYLE
import Grid from '@material-ui/core/Grid';

const ViewMyReservationModalInputs = ({ reservationData }) => {
  const getStatusValue = () => {
    switch (reservationData?.status) {
      case 'Pending':
        return 'Függőben';
      case 'Canceled':
        return 'Megszakítva';
      case 'Expired':
        return 'Lejárva';
      case 'Available':
        return 'Elérhető';
      case 'Completed':
        return 'Teljesítve';
      case 'Failed':
        return 'Sikertelen';
      default:
        return null;
    }
  };

  const properties = [
    {
      id: 'createdAt',
      label: 'Fogalalás ideje',
      value: reservationData?.createdAt
        ? new Date(reservationData.createdAt).toLocaleString()
        : '',
    },
    {
      id: 'expectedDeliveryDate',
      label: 'Érkezés várható ideje',
      value: reservationData?.expectedDeliveryDate
        ? new Date(reservationData.expectedDeliveryDate).toLocaleString()
        : '',
    },
    {
      id: 'expirationDate',
      label: 'Foglalás lejáratának ideje',
      value: reservationData?.expirationDate
        ? new Date(reservationData.expirationDate).toLocaleString()
        : '',
    },
    {
      id: 'status',
      label: 'Státusz',
      value: getStatusValue(),
    },
    {
      id: 'loanZoneName',
      label: 'Kölcsönzési pont',
      value: reservationData?.targetLoanZone?.publicName,
    },
    {
      id: 'loanZoneMail',
      label: 'Kölcsönzési pont e-mail címe',
      value: reservationData?.targetLoanZone?.pbulicContactEmail,
    },
    {
      id: 'loanZonePhone',
      label: 'Kölcsönzési pont telefonszáma',
      value: reservationData?.targetLoanZone?.pbulicContactPhone,
    },
  ];

  return (
    <Grid container direction="column" spacing={1}>
      {properties.map(property => {
        const { id, label, value } = property;

        if (!value) return null;

        return (
          <Grid item key={id}>
            <Grid container alignItems="center">
              <Grid item xs={5}>
                {label}
              </Grid>
              <Grid item>{value}</Grid>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ViewMyReservationModalInputs;
